export default "__VITE_ASSET__DQ67CoAh__"